<template>
  <div class="accountDropdown">
    <div class="accountDropdown__inner">
      <template v-if="$auth.isLogged()">
        <div key="account" class="accountDropdown__content">
          <div v-if="otherAccounts && otherAccounts.length">
            <form-multiselect
              :options="
                otherAccounts.map(account => ({
                  id: account.userId,
                  name: account.companyUserCanSwitchTo.name,
                }))
              "
              :allow-empty="false"
              :value="currentCompany"
              option-label="name"
              key-value="id"
              track-by="id"
              placeholder="Wybierz firme"
              label="Firma"
              class="accountDropdown__select"
              @input="val => $emit('switch-account', val)"
            />
          </div>
          <ul class="accountDropdown__nav">
            <li
              v-for="{ slug, name, href } in menuItems"
              :key="slug"
              class="accountDropdown__navItem"
            >
              <a v-if="href" :href="href" target="_blank" class="accountDropdown__navLink">
                {{ name }}
              </a>
              <nuxt-link v-else :to="slug" class="accountDropdown__navLink">
                {{ name }}
              </nuxt-link>
            </li>
          </ul>
          <v-button
            :text="$t('logout')"
            theme="orange"
            small-height
            full-width
            @click="$auth.logout()"
          />
        </div>
      </template>
      <template v-else>
        <div class="accountDropdown__info">
          <div class="accountDropdown__infoImage">
            <img src="/images/logged_out_img.svg" alt="" />
          </div>
          <h2 class="accountDropdown__infoTitle">Moje konto w Ofix.pl</h2>
          <p class="accountDropdown__infoText">
            Zaloguj się i zobacz zamówienia, listy zakupowe oraz wiele więcej!
          </p>
          <v-button
            :text="$t('login')"
            theme="orange"
            small-height
            full-width
            :to="localePath({ name: 'login' })"
            rel="nofollow"
          />
          <div class="accountDropdown__infoLink">
            <p>Nie masz jeszcze konta?</p>
            <nuxt-link :to="localePath({ name: 'register' })" rel="nofollow">{{
              $t('register')
            }}</nuxt-link>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import VButton from '~/components/VButton';
import FormMultiselect from '~/components/Form/FormMultiselect';

export default {
  name: 'AccountDropdown',
  components: {
    FormMultiselect,
    VButton,
  },
  props: {
    menuItems: {
      type: Array,
      default: () => [],
    },
    currentCompany: {
      type: Number,
      default: null,
    },
    otherAccounts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectValue: null,
      currentItem: 1,
    };
  },
};
</script>

<style lang="scss">
.accountDropdown {
  $root: &;
  position: absolute;
  right: -20px;
  top: 80%;
  padding-top: 3rem;
  cursor: default;
  opacity: 0;
  pointer-events: none;
  transition: opacity $tr, top $tr;

  @include rwd('ultra') {
    padding-top: 2.2rem;
  }

  @include rwd('tablet') {
    display: none;
  }

  &__inner {
    position: relative;
    background-color: $cWhite;
    width: 320px;
    box-shadow: 0 10px 20px rgba(23, 25, 51, 0.1);
    border: 1px solid $cAddLight;
    border-radius: 0 0 4px 4px;

    &:before {
      content: '';
      position: absolute;
      transform: rotate(45deg);
      right: 20px;
      top: -7px;
      width: 12px;
      height: 12px;
      background-color: $cWhite;
      border-left: 1px solid $cAddLight;
      border-top: 1px solid $cAddLight;
    }
  }

  &__content {
    padding: 2.5rem;
    text-align: center;
  }

  &__select {
    margin-bottom: 2rem;
  }

  &__nav {
    margin-bottom: 2rem;
  }

  &__navItem {
    text-align: left;
  }

  &__navLink {
    font-size: 1.6rem;
    line-height: 3.6rem;
    color: $cMainLight;
    transition: color $tr;

    &:hover {
      color: $cSec;
    }
  }

  &__info {
    padding: 2rem;
    text-align: center;
  }

  &__infoImage {
    img {
      max-width: 100%;
    }
  }

  &__infoTitle {
    margin-top: 2rem;
    font-size: 2.4rem;
    font-weight: 600;
    line-height: 3rem;
    color: $cMainDark;
  }

  &__infoText {
    margin-top: 1rem;
    margin-bottom: 2rem;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: $cMainLight;
  }

  &__infoLink {
    margin-top: 2rem;
    font-size: 1.6rem;
    line-height: 2.4rem;

    a {
      color: $cMain;
      text-decoration: underline;
      transition: color $tr;

      &:hover {
        color: $cSec;
      }
    }
  }
}
</style>
